export default "__VITE_ASSET__9cfb27b3__"